import { createContext, useContext } from 'react';

import type { PartnerCreateEditContextValue } from 'pages/partner_create_edit/types';

export const PartnerCreateEditContext = createContext({} as PartnerCreateEditContextValue);
PartnerCreateEditContext.displayName = 'PartnerCreateEditContext';

export const usePartnerCreateEdit = () => useContext(PartnerCreateEditContext);
